import { render, staticRenderFns } from "./DataImportManager.vue?vue&type=template&id=b81d8280&scoped=true"
import script from "./DataImportManager.vue?vue&type=script&lang=js"
export * from "./DataImportManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81d8280",
  null
  
)

export default component.exports